import CheckableButton from './CheckableButton';
import SearchField from './SearchField';
import SmallUserCard from './SmallUserCard';
import UserDirectoryList from './UserDirectoryList';
import UserDirectoryListItem from './UserDirectoryListItem';
import UserDirectoryPage from './UserDirectoryPage';

export const components = {
    CheckableButton,
    SearchField,
    SmallUserCard,
    UserDirectoryList,
    UserDirectoryListItem,
    UserDirectoryPage,
};
